<video
  #target
  class="video-js vjs-fluid"
  controls
  [muted]="muted"
  playsinline
  preload="auto"
  disablePictureInPicture
></video>

<ng-template cdkPortal>
  @if (videoDuration && timelineMarkers?.length) { @for (marker of
  timelineMarkers; track trackByFn($index, marker)) {
  <atx-amp-timeline-marker
    [start]="marker.start"
    [end]="marker.end"
    [previewUrl]="marker.previewUrl"
    [isAvailable]="marker.isAvailable"
    [videoDuration]="videoDuration"
    (markerClick)="onMarkerClick($event)"
  >
  </atx-amp-timeline-marker>
  } }
</ng-template>

<div class="timeline-suggestion">
  <ng-content></ng-content>
</div>
